import React from 'react';
import Tabs from '@components/common/Dashboard/DashboardTabs/Tabs';
import { TopPanelWrapper, TabRow } from '../styled';
import Summary from './Summary';
// eslint-disable-next-line react/display-name
export default ({ currentShareId, pageType }) =>
  // update when implementing shared dashboards
  (
    <TopPanelWrapper>
      <TabRow>
        <Tabs currentShareId={currentShareId} pageType={pageType} />
      </TabRow>
      <Summary currentShareId={currentShareId} pageType={pageType} />
    </TopPanelWrapper>
  );
